import mutations from '@/store/modules/database/databaseCommonState/database.mutations';
import actions from '@/store/modules/database/databaseCommonState/database.actions';
import getters from '@/store/modules/database/databaseCommonState/database.getters';
import DatabaseTypes from '@/utils/databaseTypes';
import { KeyLabel } from '@/store/mutations-typesCommon';
import { Service } from '@/utils/types/global';

export interface State {
  currentDatabaseType: KeyLabel;
  databaseServices: Array<KeyLabel>;
  currentDatabaseService: Service;
  sessionDetails:any[];
  databaseQuery:any[];
  avgCpu:number;
  avgMemory:number
}

const initialState: State = {
  currentDatabaseType: DatabaseTypes[0],
  databaseServices: [],
  currentDatabaseService: { key: '', label: '', permissions: [] },
  sessionDetails:[],
  databaseQuery:[],
  avgCpu:0,
  avgMemory:0
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};
